import styled, { css } from "styled-components";

export const BasePageRoot = styled.div(
    ({ theme }) => css`
        background-color: ${theme.palette.background};
        --base-page-padding: ${theme.spacing[5]};
        max-width: 100%;
        margin-top: var(--appbar-height);
        padding: var(--base-page-padding);
        flex: 1;
        display: flex;
        flex-direction: column;
    `,
);
